import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

export function PostCard({ p, i = 0, big = false }) {
  return (
    <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} style={{ animationDelay: `${i * 70}ms` }}
      className={`group block bg-white ring-1 ring-black/5 rounded-2xl overflow-hidden transition-shadow hover:shadow-xl ${big ? "md:grid md:grid-cols-2" : ""}`}>
      <div className={`${big ? "h-64 md:h-full" : "h-52"} overflow-hidden bg-[#EFE9E1]`}>
        {p.cover_image && <img src={p.cover_image} alt={p.cover_alt || p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transform duration-500"/>}
      </div>
      <div className={big ? "p-8 flex flex-col justify-center" : "p-5"}>
        <div className="text-xs text-[#5C6B63] mb-2">{p.publish_at && format(new Date(p.publish_at), "dd MMM yyyy")} · {p.reading_minutes} min read</div>
        <h2 className={`font-serif text-[#1C2421] ${big ? "text-3xl" : "text-xl"}`}>{p.title}</h2>
        <p className="text-sm text-[#5C6B63] mt-2 line-clamp-3">{p.excerpt}</p>
        <div className="flex gap-2 mt-3 flex-wrap">{p.tags.map((t) => <span key={t} className="text-[11px] px-2 py-0.5 rounded-full bg-[#F5F0EB] text-[#1E3A2B]">#{t}</span>)}</div>
      </div>
    </Link>
  );
}

export default function Blog() {
  const [params, setParams] = useSearchParams();
  const tag = params.get("tag");
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog", { params: tag ? { tag } : {} }).then((r) => setPosts(r.data)); }, [tag]);
  const [first, ...rest] = posts || [];

  return (
    <div className="jt-container py-16" data-testid="blog-page">
      <Seo title={tag ? `#${tag} · Jawai Journal` : "Jawai Journal: Leopard, Birding & Travel Guides"}
        description="Guides and stories from Jawai, Rajasthan: the best time for leopard sightings, birding at Jawai Dam, packing lists and safari tips."/>
      <div className="jt-eyebrow mb-3">Jawai Journal</div>
      <h1 className="font-serif text-4xl md:text-5xl text-[#1E3A2B] mb-3">Stories &amp; guides from the leopard hills</h1>
      <p className="text-[#5C6B63] max-w-2xl mb-8">Field notes from our naturalists, plus practical tips for planning your trip to Jawai.</p>
      {tag && <button onClick={() => setParams({})} className="text-sm text-[#C86D51] mb-6" data-testid="blog-clear-tag">#{tag} · show all posts ×</button>}
      {posts && posts.length === 0 && <p className="text-[#5C6B63]" data-testid="blog-empty">No posts yet.</p>}
      {first && <div className="mb-8"><PostCard p={first} big/></div>}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">{rest.map((p, i) => <PostCard key={p.id} p={p} i={i}/>)}</div>
    </div>
  );
}
